// extracted by mini-css-extract-plugin
export default {"container":"SectionImageText_container__yoNSo","image":"SectionImageText_image__YEbbQ","credit":"SectionImageText_credit__gwMmg","text":"SectionImageText_text__8bMjK"};